import React, { useState, useEffect, useRef } from 'react';
import PocketBase from 'pocketbase';

const pb = new PocketBase('https://bahcarplaza.com');

function Admin({ view, setView, setSearchTerm, setCityFilter, setSelectedCar }) {
  const [cars, setCars] = useState([]);
  const [bookings, setBookings] = useState([]);
  const [orders, setOrders] = useState([]);
  const [enquiries, setEnquiries] = useState([]);
  const [feedbacks, setFeedbacks] = useState([]); 
  const [users, setUsers] = useState([]); 
  
  const [carViews, setCarViews] = useState([]);
  const [expandedUserViews, setExpandedUserViews] = useState(null); 

  const [youtubeShorts, setYoutubeShorts] = useState([]);
  const [newVideoUrl, setNewVideoUrl] = useState("");

  const [blogs, setBlogs] = useState([]);
  const [newBlog, setNewBlog] = useState({ title: '', publish_date: '' });
  const [blogFile, setBlogFile] = useState(null);
  const contentRef = useRef(null); 

  const [rechargeAmounts, setRechargeAmounts] = useState({});

  const [adminActiveTab, setAdminActiveTab] = useState('BOOKINGS');
  const [adminStatusFilter, setAdminStatusFilter] = useState("All");
  const [orderStatusFilter, setOrderStatusFilter] = useState("All");
  const [approvalStatusFilter, setApprovalStatusFilter] = useState("All");

  const [isMobileAdminMenuOpen, setIsMobileAdminMenuOpen] = useState(false);
  const adminMenuRef = useRef(null); 

  const fetchCars = async () => { try { const records = await pb.collection('cars').getFullList({ expand: 'added_by', sort: '-created' }); setCars(records); } catch (e) { console.error(e); } };
  const fetchBookings = async () => { try { const records = await pb.collection('bookings').getFullList({ expand: 'car_id,user_id', sort: '-created' }); setBookings(records); } catch (e) { console.error(e); } };
  const fetchOrders = async () => { try { const records = await pb.collection('orders').getFullList({ expand: 'car_id,user_id', sort: '-created' }); setOrders(records); } catch (e) { console.error(e); } };
  const fetchEnquiries = async () => { try { const records = await pb.collection('contact_leads').getFullList({ sort: '-created' }); setEnquiries(records); } catch (e) { console.error(e); } };
  const fetchFeedbacks = async () => { try { const records = await pb.collection('user_feedback').getFullList({ sort: '-created', expand: 'user_id' }); setFeedbacks(records); } catch (e) { console.error(e); } };
  const fetchCarViews = async () => { try { const records = await pb.collection('cars_view').getFullList({ sort: '-created', expand: 'user_id,car_id' }); setCarViews(records); } catch (e) { console.error(e); } };
  const fetchYoutubeShorts = async () => { try { const records = await pb.collection('videos_list').getFullList({ sort: '-created' }); setYoutubeShorts(records); } catch (e) { console.error(e); } };
  const fetchBlogs = async () => { try { const records = await pb.collection('blog_post').getFullList({ sort: '-created', expand: 'author' }); setBlogs(records); } catch (e) { console.error(e); } };
  const fetchUsers = async () => { try { const records = await pb.collection('users').getFullList({ sort: '-created' }); setUsers(records); } catch (e) { console.error(e); } };

  useEffect(() => {
    fetchCars(); fetchBookings(); fetchOrders(); fetchEnquiries(); fetchFeedbacks(); fetchCarViews(); fetchYoutubeShorts(); fetchBlogs(); fetchUsers();
    const interval = setInterval(() => {
      fetchCars(); fetchBookings(); fetchOrders(); fetchEnquiries(); fetchFeedbacks(); fetchCarViews(); fetchYoutubeShorts(); fetchBlogs(); fetchUsers();
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const handlePopState = (e) => {
      if (!e.state || !e.state.dropdownOpen) setExpandedUserViews(null);
      if (!e.state || !e.state.adminMenuOpen) setIsMobileAdminMenuOpen(false);
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (adminMenuRef.current && !adminMenuRef.current.contains(event.target)) {
        if (isMobileAdminMenuOpen) {
          setIsMobileAdminMenuOpen(false);
          if (window.history.state && window.history.state.adminMenuOpen) window.history.back();
        }
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isMobileAdminMenuOpen]);

  const toggleMobileMenu = () => {
    if (isMobileAdminMenuOpen) {
      setIsMobileAdminMenuOpen(false);
      if (window.history.state && window.history.state.adminMenuOpen) window.history.back();
    } else {
      setIsMobileAdminMenuOpen(true);
      window.history.pushState({ page: 'admin', adminMenuOpen: true }, '');
    }
  };

  const handleMenuClick = (id) => {
    setAdminActiveTab(id);
    setIsMobileAdminMenuOpen(false);
    if (window.history.state && window.history.state.adminMenuOpen) window.history.back();
  };

  const handleUserClick = (userId) => {
    if (expandedUserViews === userId) {
      setExpandedUserViews(null);
      if (window.history.state && window.history.state.dropdownOpen) window.history.back();
    } else {
      setExpandedUserViews(userId);
      window.history.pushState({ page: 'admin', dropdownOpen: true }, '');
    }
  };

  const getVal = (val) => (Array.isArray(val) ? val[0] : val || "");

  const handleManualRecharge = async (user) => {
    const amountToAdd = Number(rechargeAmounts[user.id]);
    if (!amountToAdd || amountToAdd <= 0) {
      alert("Please enter a valid amount to recharge.");
      return;
    }

    try {
      const currentBalance = user.wallet_balance || 0;
      const newBalance = currentBalance + amountToAdd;
      
      await pb.collection('users').update(user.id, { wallet_balance: newBalance });
      
      alert(`₹${amountToAdd.toLocaleString()} added to ${user.name}'s Wallet Successfully!`);
      
      setRechargeAmounts(prev => ({ ...prev, [user.id]: '' }));
      fetchUsers();
    } catch (error) {
      alert("Recharge Failed: " + error.message);
    }
  };

  const handleClearWallet = async (user) => {
    if (window.confirm(`Are you sure you want to reset ${user.name}'s wallet balance to Zero (0)?`)) {
      try {
        await pb.collection('users').update(user.id, { wallet_balance: 0 });
        alert(`${user.name}'s Wallet has been cleared!`);
        setRechargeAmounts(prev => ({ ...prev, [user.id]: '' }));
        fetchUsers();
      } catch (error) {
        alert("Clear Wallet Failed: " + error.message);
      }
    }
  };

  const updateCarListingStatus = async (id, newStatus) => {
    try {
      let dataToUpdate = { status: newStatus };
      if (newStatus === 'Rejected') {
        const reason = prompt("Please provide a rejection reason:");
        if (reason) dataToUpdate.rejection_reason = reason; else return;
      } else if (newStatus === 'Approved') {
        const commission = prompt("Enter Commission Amount (₹) for this car:", "0");
        if(commission !== null) dataToUpdate.commission_amount = Number(commission);
      }
      await pb.collection('cars').update(id, dataToUpdate); 
      fetchCars();
    } catch (e) { alert("Failed to update record! Error: " + (e.data?.message || e.message)); }
  };

  const updateBookingStatus = async (id, newStatus) => {
    try { await pb.collection('bookings').update(id, { status: newStatus }); fetchBookings(); } catch (e) { alert(e.message); }
  };

  // ==========================================
  // 🚨 FIXED: SUPER POWER ORDER MANAGEMENT 🚨
  // ==========================================
  const updateOrderStatus = async (orderId, carId, newStatus) => {
    try { 
      // ১. প্রথমে অর্ডারের স্ট্যাটাস আপডেট করুন
      await pb.collection('orders').update(orderId, { payment_status: newStatus }); 
      
      // ২. যদি রিজেক্ট বা ফেইল হয়, তাহলে গাড়িটিকে আবার মার্কেটে (Approved) ফিরিয়ে দিন
      if (newStatus === 'Reject' || newStatus === 'Failed') {
        try {
          await pb.collection('cars').update(carId, { status: 'Approved' });
          alert(`Order Rejected. Car is now available in the market again!`);
        } catch (carErr) {
          alert(`Order rejected, but failed to make the car Available again. Please check Car permissions. Error: ${carErr.message}`);
        }
      } 
      // ৩. যদি ডেলিভারি বা অ্যাপ্রুভ হয়, তাহলে নিশ্চিত করুন গাড়িটি Sold হয়ে আছে
      else if (newStatus === 'Delivered' || newStatus === 'Approved') {
        try {
          await pb.collection('cars').update(carId, { status: 'Sold' });
          alert(`Order status updated to ${newStatus} successfully!`);
        } catch (carErr) {
          alert(`Order updated, but failed to change Car status to Sold. Error: ${carErr.message}`);
        }
      } else {
        alert(`Order status updated to ${newStatus}`);
      }

      // ৪. নতুন ডেটা ফেচ করুন
      fetchOrders(); 
      fetchCars();
    } catch (e) { 
      alert("Failed to update Order status: " + e.message); 
    }
  };

  const deleteRecord = async (collection, id) => {
    if (window.confirm("Are you sure you want to permanently delete this?")) {
      try { 
        await pb.collection(collection).delete(id); 
        fetchBookings(); fetchOrders(); fetchCars(); fetchEnquiries(); fetchFeedbacks(); fetchCarViews(); fetchYoutubeShorts(); fetchBlogs();
        alert("Deleted Successfully!");
      } catch (e) { alert("Delete failed: " + e.message); }
    }
  };

  const bulkDeleteUserHistory = async (userId) => {
    if (window.confirm("Are you sure you want to delete ALL view history for this user?")) {
      try {
        const userRecords = carViews.filter(v => v.user_id === userId);
        for (let record of userRecords) { await pb.collection('cars_view').delete(record.id); }
        fetchCarViews(); alert("All history deleted for this user!"); setExpandedUserViews(null);
      } catch (e) { alert("Delete failed: " + e.message); }
    }
  };

  const handleAddVideo = async () => {
    const url = newVideoUrl.trim();
    if (!url) return alert("Please enter a Video link!");
    
    let platform = "Unknown";
    let videoId = url;

    if (url.includes("youtube.com") || url.includes("youtu.be")) {
      platform = "YouTube";
      const match = url.match(/(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=|shorts\/))((\w|-){11})/);
      videoId = match ? match[1] : null;
    } else if (url.includes("instagram.com/reel/")) {
      platform = "Instagram";
      const match = url.match(/instagram\.com\/reel\/([A-Za-z0-9_-]+)/);
      videoId = match ? match[1] : null;
    } else if (url.includes("facebook.com") || url.includes("fb.watch")) {
      platform = "Facebook";
      videoId = url; 
    }

    if (!videoId || platform === "Unknown") {
      return alert("Invalid or Unsupported URL! Please use a valid YouTube, Facebook, or Instagram Reel link.");
    }

    try {
      await pb.collection('videos_list').create({ platform: platform, video_id: videoId, original_url: url });
      alert(`${platform} Video Added Successfully!`);
      setNewVideoUrl(""); fetchYoutubeShorts();
    } catch (e) { alert("Error adding video: " + e.message); }
  };

  const handlePublishBlog = async (e) => {
    e.preventDefault();
    const contentHTML = contentRef.current.innerHTML;

    if (!newBlog.title || !contentHTML || !blogFile || !newBlog.publish_date) {
      return alert("Please fill all fields, write content, and select a cover image!");
    }

    try {
      const formData = new FormData();
      formData.append('title', newBlog.title);
      
      const generatedSlug = newBlog.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)+/g, '');
      formData.append('slug', generatedSlug);
      
      formData.append('content', contentHTML);
      formData.append('file', blogFile); 
      
      if (pb.authStore.model?.id) {
        formData.append('author', pb.authStore.model.id); 
      }
      
      formData.append('publish_date', new Date(newBlog.publish_date).toISOString());

      await pb.collection('blog_post').create(formData);
      
      alert("Blog Published Successfully!");
      setNewBlog({ title: '', publish_date: '' });
      setBlogFile(null);
      if(contentRef.current) contentRef.current.innerHTML = ''; 
      fetchBlogs();

    } catch (error) {
      alert("Error publishing blog: " + error.message);
    }
  };

  const formatText = (command) => {
    document.execCommand(command, false, null);
    if(contentRef.current) contentRef.current.focus();
  };

  const pendingOrdersCount = orders.filter(o => o.payment_status === 'Pending').length;
  const pendingListingCount = cars.filter(car => car.status === 'Pending').length;
  const inputStyle = { padding: '15px', borderRadius: '15px', border: '1px solid #eee', backgroundColor: '#f9f9f9', fontWeight: 'bold', width: '100%', boxSizing: 'border-box' };

  const groupedUserViews = {};
  carViews.forEach(viewRecord => {
    const user = viewRecord.expand?.user_id;
    const car = viewRecord.expand?.car_id;
    if (!user || !car) return;

    if (!groupedUserViews[user.id]) {
      groupedUserViews[user.id] = { user: user, cars: {}, totalUniqueCars: 0, latestVisit: viewRecord.created };
    }
    if (new Date(viewRecord.created) > new Date(groupedUserViews[user.id].latestVisit)) {
      groupedUserViews[user.id].latestVisit = viewRecord.created;
    }
    if (!groupedUserViews[user.id].cars[car.id]) {
      groupedUserViews[user.id].cars[car.id] = { carDetails: car, viewCount: 0, latestViewRecordId: viewRecord.id, lastViewedAt: viewRecord.created };
      groupedUserViews[user.id].totalUniqueCars += 1;
    }
    groupedUserViews[user.id].cars[car.id].viewCount += 1;
    if (new Date(viewRecord.created) > new Date(groupedUserViews[user.id].cars[car.id].lastViewedAt)) {
      groupedUserViews[user.id].cars[car.id].lastViewedAt = viewRecord.created;
      groupedUserViews[user.id].cars[car.id].latestViewRecordId = viewRecord.id;
    }
  });
  const uniqueUserCount = Object.keys(groupedUserViews).length;

  const adminMenuItems = [
    { id: 'ENQUIRY', name: `Enquiries`, count: enquiries.length, icon: '📩' },
    { id: 'BOOKINGS', name: `Bookings`, count: bookings.length, icon: '🗓️' },
    { id: 'ORDERS', name: `Orders`, count: pendingOrdersCount, icon: '📦' },
    { id: 'APPROVALS', name: `Approvals`, count: pendingListingCount, icon: '✅' },
    { id: 'REVIEWS', name: `Reviews`, count: feedbacks.length, icon: '⭐' },
    { id: 'WALLET', name: `Wallets`, count: users.length, icon: '💰' }, 
    { id: 'CARS_VIEW', name: `Cars View`, count: uniqueUserCount, icon: '👁️' },
    { id: 'VIDEOS', name: `Videos`, count: youtubeShorts.length, icon: '▶️' },
    { id: 'BLOGS', name: `Blogs`, count: blogs.length, icon: '📝' } 
  ];

  return (
    <div style={{ backgroundColor: '#f3f4f6', minHeight: '100vh', fontFamily: 'sans-serif' }}>
      
      <style>
        {`
          /* 🚨 DESKTOP LAYOUT 🚨 */
          .admin-layout-container { padding: 40px; max-width: 1400px; margin: 0 auto; display: flex; flex-direction: column; }
          .admin-top-bar { display: flex; justify-content: space-between; align-items: center; margin-bottom: 30px; padding-bottom: 20px; border-bottom: 2px solid #e5e7eb; }
          .admin-main-wrapper { display: flex; gap: 40px; align-items: flex-start; }
          
          /* Sidebar Styling */
          .desktop-sidebar { width: 260px; flex-shrink: 0; background: #fff; padding: 25px; border-radius: 20px; box-shadow: 0 5px 20px rgba(0,0,0,0.03); position: sticky; top: 40px; display: flex; flex-direction: column; gap: 10px; }
          .sidebar-btn { text-align: left; padding: 15px 20px; border-radius: 15px; border: none; font-weight: 900; font-size: 13px; cursor: pointer; transition: 0.3s; display: flex; justify-content: space-between; align-items: center; text-transform: uppercase; }
          .sidebar-btn-left { display: flex; align-items: center; gap: 10px; }
          .sidebar-badge { background: #f1f4f8; color: #002f34; padding: 3px 8px; border-radius: 10px; font-size: 11px; }
          
          .sidebar-btn.active { background-color: #ef5e33; color: #fff; box-shadow: 0 5px 15px rgba(239,94,51,0.2); }
          .sidebar-btn.active .sidebar-badge { background-color: #fff; color: #ef5e33; }
          .sidebar-btn.inactive { background-color: transparent; color: #555; }
          .sidebar-btn.inactive:hover { background-color: #f9f9f9; color: #002f34; }
          
          .admin-content-area { flex: 1; min-width: 0; }
          
          .desktop-back-btn { display: flex; }
          .mobile-back-btn { display: none !important; }
          .mobile-menu-wrapper { display: none; }
          
          .admin-card { display: flex; align-items: center; gap: 20px; }
          .admin-card-img { width: 140px; height: 90px; object-fit: cover; border-radius: 12px; }

          .rich-text-editor:empty:before { content: attr(data-placeholder); color: #aaa; font-style: italic; }
          .editor-toolbar button { padding: 8px 15px; border: 1px solid #ddd; background: #fff; cursor: pointer; border-radius: 8px; font-size: 14px; font-weight: bold; transition: 0.2s; color: #002f34; }
          .editor-toolbar button:hover { background: #ef5e33; color: white; border-color: #ef5e33; }

          /* 🚨 MOBILE LAYOUT 🚨 */
          @media (max-width: 900px) {
            .admin-layout-container { padding: 15px !important; }
            .admin-main-wrapper { flex-direction: column; gap: 20px; }
            .desktop-sidebar { display: none; } 
            
            .admin-top-bar { flex-direction: row; justify-content: space-between; align-items: center; margin-bottom: 20px; gap: 10px; padding-bottom: 15px; border-bottom: none; }
            .admin-title-text { font-size: 22px !important; white-space: nowrap; }
            
            .desktop-back-btn { display: none !important; }
            .mobile-back-btn {
              display: flex !important; width: 45px; height: 45px; padding: 0; border-radius: 50%;
              background-color: #002f34; color: #fff; border: none; cursor: pointer;
              align-items: center; justify-content: center; box-shadow: 0 4px 10px rgba(0,0,0,0.1); flex-shrink: 0; transition: 0.3s;
            }
            .mobile-back-btn:active { background-color: #ef5e33; }
            
            .mobile-menu-wrapper { display: block; position: relative; }
            .mobile-menu-btn { 
              background: #ef5e33; color: #fff; border: none; padding: 10px 15px; 
              border-radius: 12px; font-weight: 900; font-size: 14px; cursor: pointer; 
              display: flex; align-items: center; gap: 6px; box-shadow: 0 4px 10px rgba(239,94,51,0.2); 
            }
            
            .mobile-dropdown-content { 
              position: absolute; top: 120%; left: 0; 
              background: #002f34; width: 250px; border-radius: 15px; 
              box-shadow: 0 15px 40px rgba(0,0,0,0.3); border: 1px solid rgba(255,255,255,0.1); 
              z-index: 9999; padding: 15px; display: flex; flex-direction: column; gap: 8px; 
            }
            .mobile-dropdown-content button { 
              padding: 12px 15px; text-align: left; background: none; border: none; border-radius: 10px; 
              font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; 
              font-weight: 800; font-size: 13px; color: #b0c4c6; 
              cursor: pointer; transition: 0.3s; display: flex; justify-content: space-between; align-items: center; letter-spacing: 0.5px;
            }
            .mobile-dropdown-content button:hover { background: rgba(255,255,255,0.05); color: #fff; }
            .mobile-dropdown-content button.active { 
              background: #ef5e33; color: #fff; box-shadow: 0 4px 10px rgba(239,94,51,0.3);
            }

            .admin-card { flex-direction: column; align-items: stretch; text-align: left; }
            .admin-card-img { width: 100% !important; height: 180px !important; margin: 0 auto; }
            .admin-card-actions { display: flex; flex-direction: row !important; flex-wrap: wrap; justify-content: space-between; align-items: center; gap: 10px; text-align: left !important; }
          }
        `}
      </style>

      <div className="admin-layout-container">
        
        <div className="admin-top-bar">
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            
            <div className="mobile-menu-wrapper" ref={adminMenuRef}>
              <button className="mobile-menu-btn" onClick={toggleMobileMenu}>☰ Menu</button>
              {isMobileAdminMenuOpen && (
                <div className="mobile-dropdown-content">
                  {adminMenuItems.map(item => (
                    <button key={item.id} className={adminActiveTab === item.id ? 'active' : ''} onClick={() => handleMenuClick(item.id)}>
                      <div style={{display: 'flex', alignItems:'center', gap:'10px'}}>
                        <span>{item.icon}</span> {item.name}
                      </div>
                      <span className="sidebar-badge" style={{backgroundColor: adminActiveTab === item.id ? '#fff' : 'rgba(255,255,255,0.1)', color: adminActiveTab === item.id ? '#ef5e33' : '#fff'}}>{item.count}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>

            <h1 className="admin-title-text" style={{ fontSize: '32px', fontWeight: '900', color: '#002f34', margin: 0, textTransform: 'uppercase' }}>ADMIN PANEL</h1>
          </div>
          
          <button className="desktop-back-btn" onClick={() => setView('home')} style={{ padding: '12px 25px', backgroundColor: '#002f34', color: '#fff', border: 'none', borderRadius: '20px', fontWeight: '900', fontSize: '12px', cursor: 'pointer', alignItems: 'center', gap: '8px', textTransform: 'uppercase', boxShadow: '0 5px 15px rgba(0,47,52,0.2)', transition: '0.3s' }} onMouseOver={(e) => e.target.style.backgroundColor = '#ef5e33'} onMouseOut={(e) => e.target.style.backgroundColor = '#002f34'}>
            🏠 Back to Home
          </button>
          <button className="mobile-back-btn" title="Back to Home" onClick={() => setView('home')}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
          </button>
        </div>

        <div className="admin-main-wrapper">
          
          <aside className="desktop-sidebar">
            {adminMenuItems.map(item => (
              <button 
                key={item.id} 
                onClick={() => setAdminActiveTab(item.id)} 
                className={`sidebar-btn ${adminActiveTab === item.id ? 'active' : 'inactive'}`}
              >
                <div className="sidebar-btn-left">
                  <span style={{fontSize: '16px'}}>{item.icon}</span> 
                  {item.name}
                </div>
                <span className="sidebar-badge">{item.count}</span>
              </button>
            ))}
          </aside>

          <section className="admin-content-area">
            
            {adminActiveTab === 'WALLET' ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <h2 style={{ margin: 0, color: '#002f34', fontSize: '24px', fontWeight: '900', textTransform: 'uppercase' }}>Customer Wallets</h2>
                </div>
                
                {users.map(user => (
                  <div key={user.id} style={{ backgroundColor: '#fff', padding: '20px', borderRadius: '20px', border: '1px solid #eee', boxShadow: '0 2px 10px rgba(0,0,0,0.02)', display: 'flex', flexWrap: 'wrap', gap: '20px', alignItems: 'center', justifyContent: 'space-between' }}>
                    
                    <div style={{ flex: 1, minWidth: '250px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '10px' }}>
                        <div style={{ width: '50px', height: '50px', backgroundColor: '#002f34', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: '900', fontSize: '20px', overflow: 'hidden' }}>
                          {user.avatar ? <img src={`https://bahcarplaza.com/api/files/${user.collectionId}/${user.id}/${user.avatar}`} style={{ width: '100%', height: '100%', objectFit: 'cover' }} alt="Avatar" /> : (user.name?.charAt(0).toUpperCase() || 'U')}
                        </div>
                        <div>
                          <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '900', color: '#002f34', textTransform: 'uppercase' }}>{user.name || 'No Name'}</h3>
                          <p style={{ margin: '3px 0 0 0', fontSize: '12px', color: '#666', fontWeight: 'bold' }}>📞 +91 {user.phone || 'N/A'} &nbsp;|&nbsp; ✉️ {user.email}</p>
                        </div>
                      </div>
                      <p style={{ margin: '15px 0 0 0', fontSize: '12px', color: '#888', fontWeight: 'bold' }}>
                        📍 {user.address_line ? `${user.address_line}, ${user.landmark ? user.landmark + ',' : ''} ${user.city}, ${user.state} - ${user.pin_code}` : 'Address not updated'}
                      </p>
                    </div>
                    
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px', alignItems: 'center', minWidth: '150px', backgroundColor: '#f5fff9', padding: '15px', borderRadius: '15px', border: '1px solid #1db954' }}>
                      <span style={{ fontSize: '11px', fontWeight: '900', color: '#002f34', textTransform: 'uppercase' }}>Current Balance</span>
                      <h2 style={{ margin: 0, fontSize: '28px', color: '#1db954', fontWeight: '900' }}>₹{(user.wallet_balance || 0).toLocaleString()}</h2>
                    </div>

                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap', minWidth: '250px' }}>
                      <input 
                        type="number" 
                        placeholder="Amount (₹)" 
                        value={rechargeAmounts[user.id] || ''}
                        onChange={(e) => setRechargeAmounts({ ...rechargeAmounts, [user.id]: e.target.value })}
                        style={{ flex: 1, padding: '12px 15px', borderRadius: '12px', border: '2px solid #ddd', fontWeight: 'bold', fontSize: '14px', outline: 'none' }}
                      />
                      <button onClick={() => handleManualRecharge(user)} style={{ backgroundColor: '#002f34', color: '#fff', border: 'none', padding: '12px 20px', borderRadius: '12px', fontWeight: '900', fontSize: '12px', cursor: 'pointer', transition: '0.3s', boxShadow: '0 4px 10px rgba(0,47,52,0.2)' }} onMouseOver={(e) => e.target.style.backgroundColor = '#ef5e33'} onMouseOut={(e) => e.target.style.backgroundColor = '#002f34'}>
                        + ADD
                      </button>
                      <button onClick={() => handleClearWallet(user)} style={{ backgroundColor: '#ffebeb', color: '#dc3545', border: 'none', width: '40px', height: '40px', borderRadius: '12px', fontWeight: '900', fontSize: '16px', cursor: 'pointer', transition: '0.3s', display: 'flex', alignItems: 'center', justifyContent: 'center' }} title="Clear Wallet to 0" onMouseOver={(e) => { e.target.style.backgroundColor = '#dc3545'; e.target.style.color = '#fff'; }} onMouseOut={(e) => { e.target.style.backgroundColor = '#ffebeb'; e.target.style.color = '#dc3545'; }}>
                        🗑️
                      </button>
                    </div>

                  </div>
                ))}
                {users.length === 0 && <p style={{ textAlign: 'center', color: '#aaa', fontWeight: 'bold', padding: '50px' }}>No users found.</p>}
              </div>

            ) : adminActiveTab === 'BLOGS' ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '30px' }}>
                 <div style={{ backgroundColor: '#fff', padding: '30px', borderRadius: '20px', boxShadow: '0 5px 20px rgba(0,0,0,0.03)' }}>
                    <h2 style={{ margin: '0 0 20px 0', color: '#002f34', fontSize: '24px', fontWeight: '900', textTransform: 'uppercase' }}>Publish New Blog</h2>
                    
                    <form onSubmit={handlePublishBlog} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                      
                      <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
                        <input 
                          required type="text" placeholder="Blog Title (e.g., Top 10 Cars in 2026)" value={newBlog.title}
                          onChange={(e) => setNewBlog({...newBlog, title: e.target.value})}
                          style={{ ...inputStyle, flex: 2 }} 
                        />
                        <input 
                          required type="date" title="Publish Date" value={newBlog.publish_date}
                          onChange={(e) => setNewBlog({...newBlog, publish_date: e.target.value})}
                          style={{ ...inputStyle, flex: 1, cursor: 'pointer' }} 
                        />
                      </div>

                      <div style={{ ...inputStyle, padding: '15px 20px', display: 'flex', alignItems: 'center', gap: '15px' }}>
                        <span style={{ fontSize: '14px', color: '#666', fontWeight: 'bold' }}>Cover Photo:</span>
                        <input 
                          required type="file" accept="image/*"
                          onChange={(e) => setBlogFile(e.target.files[0])}
                        />
                      </div>

                      <div style={{ border: '2px solid #eee', borderRadius: '15px', overflow: 'hidden' }}>
                        <div className="editor-toolbar" style={{ backgroundColor: '#f1f4f8', padding: '10px 15px', borderBottom: '2px solid #eee', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                          <button type="button" onClick={() => formatText('bold')} title="Bold"><b>B</b></button>
                          <button type="button" onClick={() => formatText('italic')} title="Italic"><i>I</i></button>
                          <button type="button" onClick={() => formatText('underline')} title="Underline"><u>U</u></button>
                          <div style={{ width: '1px', backgroundColor: '#ddd', margin: '0 5px' }}></div>
                          <button type="button" onClick={() => formatText('insertUnorderedList')} title="Bullet List">• Bullet List</button>
                          <button type="button" onClick={() => formatText('insertOrderedList')} title="Number List">1. Number List</button>
                          <span style={{ fontSize: '12px', color: '#888', alignSelf: 'center', marginLeft: 'auto', fontWeight: 'bold' }}>
                            * You can also paste formatted text from Word.
                          </span>
                        </div>
                        <div 
                          ref={contentRef}
                          className="rich-text-editor"
                          contentEditable="true"
                          data-placeholder="Write or Paste your rich text blog content here..."
                          style={{ padding: '20px', minHeight: '300px', outline: 'none', backgroundColor: '#fff', fontSize: '15px', color: '#333', lineHeight: '1.8', whiteSpace: 'pre-wrap' }}
                        ></div>
                      </div>

                      <button type="submit" style={{ backgroundColor: '#1db954', color: '#fff', border: 'none', padding: '18px', borderRadius: '15px', fontWeight: '900', fontSize: '16px', cursor: 'pointer', boxShadow: '0 5px 15px rgba(29, 185, 84, 0.3)', transition: '0.3s', textTransform: 'uppercase' }}>
                        🚀 PUBLISH BLOG
                      </button>
                    </form>
                 </div>

                 <div style={{ backgroundColor: '#fff', padding: '30px', borderRadius: '20px', boxShadow: '0 5px 20px rgba(0,0,0,0.03)' }}>
                    <h3 style={{ margin: '0 0 20px 0', color: '#002f34', fontSize: '18px', fontWeight: '900', textTransform: 'uppercase', borderBottom: '2px solid #eee', paddingBottom: '10px' }}>
                      Published Blogs ({blogs.length})
                    </h3>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                      {blogs.map(blog => (
                        <div key={blog.id} style={{ display: 'flex', alignItems: 'center', gap: '20px', padding: '15px', border: '1px solid #eee', borderRadius: '15px', backgroundColor: '#fcfcfc' }}>
                          <div style={{ width: '100px', height: '70px', borderRadius: '10px', overflow: 'hidden', flexShrink: 0, boxShadow: '0 2px 5px rgba(0,0,0,0.1)' }}>
                            <img src={`https://bahcarplaza.com/api/files/${blog.collectionId}/${blog.id}/${blog.file}`} style={{ width: '100%', height: '100%', objectFit: 'cover' }} alt="Cover" />
                          </div>
                          <div style={{ flex: 1 }}>
                            <h4 style={{ margin: '0 0 5px 0', color: '#002f34', fontSize: '16px', fontWeight: '900' }}>{blog.title}</h4>
                            <div style={{ display: 'flex', gap: '15px', fontSize: '12px', color: '#666', fontWeight: 'bold' }}>
                              <span>✍️ {blog.expand?.author?.name || 'Admin'}</span>
                              <span>🗓️ {new Date(blog.publish_date || blog.created).toLocaleDateString('en-IN', { dateStyle: 'medium' })}</span>
                            </div>
                          </div>
                          <button onClick={() => deleteRecord('blog_post', blog.id)} style={{ backgroundColor: '#fff', border: '2px solid #dc3545', color: '#dc3545', padding: '10px 15px', borderRadius: '10px', fontWeight: '900', fontSize: '11px', cursor: 'pointer', transition: '0.3s' }} onMouseOver={(e) => { e.target.style.backgroundColor = '#dc3545'; e.target.style.color = '#fff'; }} onMouseOut={(e) => { e.target.style.backgroundColor = '#fff'; e.target.style.color = '#dc3545'; }}>
                            DELETE
                          </button>
                        </div>
                      ))}
                      {blogs.length === 0 && <p style={{ color: '#aaa', fontWeight: 'bold', textAlign: 'center', padding: '20px 0' }}>No blogs published yet.</p>}
                    </div>
                 </div>
              </div>

            ) : adminActiveTab === 'VIDEOS' ? (
              <div style={{ backgroundColor: '#fff', padding: '30px', borderRadius: '20px', boxShadow: '0 5px 20px rgba(0,0,0,0.03)' }}>
                 <h2 style={{ margin: '0 0 20px 0', color: '#002f34', fontSize: '24px', fontWeight: '900', textTransform: 'uppercase' }}>Add New Video (YT/FB/Insta)</h2>
                 <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', marginBottom: '40px' }}>
                    <input 
                      type="text" 
                      placeholder="Paste YouTube, Facebook or Instagram Reel Link here" 
                      value={newVideoUrl}
                      onChange={(e) => setNewVideoUrl(e.target.value)}
                      style={{ flex: 1, padding: '15px 20px', borderRadius: '15px', border: '2px solid #eee', fontSize: '14px', fontWeight: 'bold', outline: 'none' }} 
                    />
                    <button 
                      onClick={handleAddVideo}
                      style={{ backgroundColor: '#ef5e33', color: '#fff', border: 'none', padding: '15px 30px', borderRadius: '15px', fontWeight: '900', fontSize: '14px', cursor: 'pointer', boxShadow: '0 5px 15px rgba(239,94,51,0.3)', transition: '0.3s' }}
                    >
                      ➕ ADD VIDEO
                    </button>
                 </div>

                 <h3 style={{ margin: '0 0 20px 0', color: '#002f34', fontSize: '18px', fontWeight: '900', textTransform: 'uppercase', borderBottom: '2px solid #eee', paddingBottom: '10px' }}>Active Videos on Website ({youtubeShorts.length})</h3>
                 
                 <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '20px' }}>
                   {youtubeShorts.map(video => (
                     <div key={video.id} style={{ position: 'relative', borderRadius: '15px', overflow: 'hidden', boxShadow: '0 5px 15px rgba(0,0,0,0.1)', border: '2px solid #f1f4f8', backgroundColor: '#f9f9f9', padding: '15px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                       
                       <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                         <span style={{ 
                            backgroundColor: video.platform === 'YouTube' ? '#ff0000' : video.platform === 'Facebook' ? '#1877F2' : '#E1306C', 
                            color: '#fff', fontSize: '10px', fontWeight: '900', padding: '4px 8px', borderRadius: '8px' 
                         }}>
                           {video.platform}
                         </span>
                         <button 
                           onClick={() => deleteRecord('videos_list', video.id)} 
                           style={{ backgroundColor: '#dc3545', color: '#fff', border: 'none', width: '25px', height: '25px', borderRadius: '5px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                           title="Delete Video"
                         >
                           🗑️
                         </button>
                       </div>
                       
                       <p style={{ margin: 0, fontSize: '11px', color: '#555', wordBreak: 'break-all', fontWeight: 'bold' }}>
                         {video.original_url?.substring(0, 50)}...
                       </p>

                     </div>
                   ))}
                   {youtubeShorts.length === 0 && <p style={{ color: '#aaa', fontWeight: 'bold' }}>No Videos added yet.</p>}
                 </div>
              </div>

            ) : adminActiveTab === 'CARS_VIEW' ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                {Object.keys(groupedUserViews).length > 0 ? Object.values(groupedUserViews)
                  .sort((a, b) => new Date(b.latestVisit) - new Date(a.latestVisit))
                  .map(userData => (
                  <div key={userData.user.id} style={{ backgroundColor: '#fff', borderRadius: '20px', border: '1px solid #eee', boxShadow: '0 2px 10px rgba(0,0,0,0.02)', overflow: 'hidden' }}>
                    
                    <div onClick={() => handleUserClick(userData.user.id)} style={{ padding: '20px', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: expandedUserViews === userData.user.id ? '#f9f9f9' : '#fff', transition: '0.3s' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flexWrap: 'wrap' }}>
                        <div style={{ width: '50px', height: '50px', backgroundColor: '#002f34', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: '900', fontSize: '20px', overflow: 'hidden', border: '2px solid #ef5e33', flexShrink: 0 }}>
                          {userData.user.avatar ? <img src={`https://bahcarplaza.com/api/files/${userData.user.collectionId}/${userData.user.id}/${userData.user.avatar}`} style={{ width: '100%', height: '100%', objectFit: 'cover' }} alt="Avatar" /> : (userData.user.name?.charAt(0).toUpperCase() || 'U')}
                        </div>
                        <div>
                          <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '900', color: '#002f34', textTransform: 'uppercase' }}>{userData.user.name || 'Anonymous User'}</h3>
                          
                          <p style={{ margin: '4px 0 0 0', fontSize: '11px', color: '#666', fontWeight: 'bold' }}>
                            📞 {userData.user.phone || 'N/A'} &nbsp;|&nbsp; ✉️ {userData.user.email} &nbsp;|&nbsp; <span style={{color: '#ef5e33'}}>⏱️ Last Visit: {new Date(userData.latestVisit).toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' })}</span>
                          </p>

                        </div>
                      </div>
                      
                      <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                        <span style={{ backgroundColor: '#ef5e33', color: '#fff', padding: '6px 12px', borderRadius: '20px', fontSize: '11px', fontWeight: '900', boxShadow: '0 2px 5px rgba(239,94,51,0.3)', whiteSpace: 'nowrap' }}>
                          👁️ Unique Cars: {userData.totalUniqueCars}
                        </span>
                        <span style={{ fontSize: '18px', fontWeight: '900', color: '#aaa', transform: expandedUserViews === userData.user.id ? 'rotate(180deg)' : 'rotate(0deg)', transition: '0.3s' }}>▼</span>
                      </div>
                    </div>

                    {expandedUserViews === userData.user.id && (
                      <div style={{ padding: '20px', borderTop: '1px solid #eee', backgroundColor: '#fcfcfc' }}>
                        
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                          <h4 style={{ margin: 0, color: '#002f34', fontWeight: '900', fontSize: '14px', textTransform: 'uppercase' }}>Browsing History</h4>
                          <button onClick={() => bulkDeleteUserHistory(userData.user.id)} style={{ backgroundColor: 'rgba(220, 53, 69, 0.1)', color: '#dc3545', border: 'none', padding: '8px 15px', borderRadius: '10px', fontWeight: '900', fontSize: '10px', cursor: 'pointer', transition: '0.3s' }} onMouseOver={(e) => { e.target.style.backgroundColor = '#dc3545'; e.target.style.color = '#fff'; }} onMouseOut={(e) => { e.target.style.backgroundColor = 'rgba(220, 53, 69, 0.1)'; e.target.style.color = '#dc3545'; }}>
                            🗑️ CLEAR ALL HISTORY
                          </button>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                          {Object.values(userData.cars)
                            .sort((a, b) => new Date(b.lastViewedAt) - new Date(a.lastViewedAt)) 
                            .map(item => (
                            <div key={item.carDetails.id} style={{ backgroundColor: '#fff', padding: '15px', borderRadius: '15px', border: '1px solid #eee', display: 'flex', alignItems: 'center', gap: '20px', flexWrap: 'wrap' }}>
                              
                              <div onClick={() => { setSelectedCar(item.carDetails); setView('details'); }} style={{ cursor: 'pointer', overflow: 'hidden', borderRadius: '10px', position: 'relative' }}>
                                <img style={{ height: '70px', width: '100px', objectFit: 'cover' }} src={`https://bahcarplaza.com/api/files/${item.carDetails.collectionId}/${item.carDetails.id}/${getVal(item.carDetails.image)}`} alt="car" />
                                
                                {item.viewCount > 1 && (
                                  <div style={{ position: 'absolute', top: '4px', right: '4px', backgroundColor: '#ef5e33', color: '#fff', fontSize: '11px', fontWeight: '900', width: '22px', height: '22px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '2px solid #fff', boxShadow: '0 2px 5px rgba(0,0,0,0.2)' }}>
                                    {item.viewCount}
                                  </div>
                                )}

                              </div>
                              
                              <div style={{ flex: 1 }}>
                                <h4 onClick={() => { setSelectedCar(item.carDetails); setView('details'); }} style={{ margin: '0 0 5px 0', fontWeight: '900', color: '#002f34', textTransform: 'uppercase', fontSize: '15px', cursor: 'pointer' }}>🚗 {item.carDetails.brand} {item.carDetails.model}</h4>
                                <div style={{ display: 'flex', gap: '15px', fontSize: '11px', color: '#666', fontWeight: 'bold' }}>
                                  <span>💰 ₹{item.carDetails.price?.toLocaleString()}</span>
                                  <span>🗓️ Last Viewed: {new Date(item.lastViewedAt).toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' })}</span>
                                </div>
                              </div>

                              <div>
                                <button onClick={() => deleteRecord('cars_view', item.latestViewRecordId)} title="Remove from history" style={{ background: 'none', border: 'none', color: '#aaa', fontSize: '18px', cursor: 'pointer', transition: '0.2s' }} onMouseOver={(e) => e.target.style.color = '#dc3545'} onMouseOut={(e) => e.target.style.color = '#aaa'}>
                                  ✖
                                </button>
                              </div>

                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                  </div>
                )) : <p style={{ textAlign: 'center', padding: '50px', color: '#aaa', fontWeight: 'bold' }}>No viewing history available yet.</p>}
              </div>

            ) : adminActiveTab === 'REVIEWS' ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                {feedbacks.length > 0 ? feedbacks.map(fb => {
                  const user = fb.expand?.user_id;
                  return (
                    <div key={fb.id} style={{ backgroundColor: '#fff', padding: '25px', borderRadius: '20px', border: '1px solid #eee', boxShadow: '0 2px 10px rgba(0,0,0,0.02)', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '15px', flexWrap: 'wrap' }}>
                      <div style={{ flex: 1, minWidth: '250px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '15px' }}>
                          <div style={{ width: '45px', height: '45px', backgroundColor: '#ef5e33', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: '900', fontSize: '20px', overflow: 'hidden', border: '2px solid #ef5e33' }}>
                            {user?.avatar ? <img src={`https://bahcarplaza.com/api/files/${user.collectionId}/${user.id}/${user.avatar}`} style={{ width: '100%', height: '100%', objectFit: 'cover' }} alt="Avatar" /> : (user?.name?.charAt(0).toUpperCase() || 'U')}
                          </div>
                          <div>
                            <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '900', color: '#002f34', textTransform: 'uppercase' }}>{user?.name || 'Anonymous User'}</h3>
                            <p style={{ margin: 0, fontSize: '11px', color: '#aaa', fontWeight: 'bold' }}>🗓️ {new Date(fb.created).toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' })}</p>
                          </div>
                        </div>
                        <div style={{ backgroundColor: '#f9f9f9', padding: '15px 20px', borderRadius: '12px', borderLeft: '4px solid #ef5e33', fontStyle: 'italic', fontSize: '14px', color: '#555', lineHeight: '1.6' }}>
                          "{fb.feedback_text}"
                        </div>
                      </div>
                      
                      <div style={{ display: 'flex', alignItems: 'center', alignSelf: 'center' }}>
                        <button onClick={() => deleteRecord('user_feedback', fb.id)} style={{ backgroundColor: '#fff', color: '#dc3545', border: '1px solid #dc3545', padding: '12px 20px', borderRadius: '12px', fontWeight: '900', fontSize: '11px', cursor: 'pointer', transition: '0.3s', whiteSpace: 'nowrap' }} onMouseOver={(e) => { e.target.style.backgroundColor = '#dc3545'; e.target.style.color = '#fff'; }} onMouseOut={(e) => { e.target.style.backgroundColor = '#fff'; e.target.style.color = '#dc3545'; }}>
                          🗑️ DELETE REVIEW
                        </button>
                      </div>
                    </div>
                  );
                }) : <p style={{ textAlign: 'center', padding: '50px', color: '#aaa', fontWeight: 'bold' }}>No reviews found.</p>}
              </div>

            ) : adminActiveTab === 'ENQUIRY' ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                {enquiries.length > 0 ? enquiries.map(lead => (
                  <div key={lead.id} style={{ backgroundColor: '#fff', padding: '20px', borderRadius: '20px', border: '1px solid #eee', position: 'relative', boxShadow: '0 2px 10px rgba(0,0,0,0.02)' }}>
                    <div className="admin-card-actions" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                      <div style={{ flex: 1 }}>
                        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                          <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '900', color: '#002f34', textTransform: 'uppercase' }}>👤 {lead.first_name} {lead.last_name}</h3>
                          <span style={{ backgroundColor: '#E8F0FE', color: '#1A73E8', fontSize: '9px', fontWeight: '900', padding: '4px 10px', borderRadius: '8px', textTransform: 'uppercase' }}>Contact Lead</span>
                        </div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', fontSize: '12px', color: '#666', fontWeight: 'bold', marginBottom: '15px' }}>
                          <span>✉️ {lead.email}</span>
                          <span>📞 {lead.phone}</span>
                          <span>🗓️ {new Date(lead.created).toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' })}</span>
                        </div>
                        <div style={{ backgroundColor: '#f9f9f9', padding: '15px', borderRadius: '12px', borderLeft: '4px solid #ef5e33', fontStyle: 'italic', fontSize: '13px', color: '#444' }}>
                          "{lead.message}"
                        </div>
                      </div>
                      <div style={{ marginLeft: '20px' }}>
                        <button onClick={() => deleteRecord('contact_leads', lead.id)} style={{ backgroundColor: '#fff', border: '1px solid #dc3545', color: '#dc3545', padding: '8px 15px', borderRadius: '10px', fontSize: '10px', fontWeight: '900', cursor: 'pointer', transition: '0.3s' }} onMouseOver={(e) => { e.target.style.backgroundColor = '#dc3545'; e.target.style.color = '#fff'; }} onMouseOut={(e) => { e.target.style.backgroundColor = '#fff'; e.target.style.color = '#dc3545'; }}>
                          DELETE ENQUIRY
                        </button>
                      </div>
                    </div>
                  </div>
                )) : <p style={{ textAlign: 'center', padding: '50px', color: '#aaa', fontWeight: 'bold' }}>No new enquiries found.</p>}
              </div>

            ) : adminActiveTab === 'BOOKINGS' ? (
              <>
                <div style={{ marginBottom: '20px', display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                  {['All', 'Pending', 'Confirmed', 'Cancelled'].map(s => (
                    <button key={s} onClick={() => setAdminStatusFilter(s)} style={{ padding: '8px 20px', borderRadius: '20px', border: adminStatusFilter === s ? 'none' : '1px solid #ddd', fontSize: '10px', fontWeight: '900', textTransform: 'uppercase', cursor: 'pointer', backgroundColor: adminStatusFilter === s ? '#002f34' : '#fff', color: adminStatusFilter === s ? '#fff' : '#888', transition: '0.2s' }}>
                      {s} ({s === 'All' ? bookings.length : bookings.filter(b => b.status === s).length})
                    </button>
                  ))}
                </div>
                
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  {bookings.filter(b => adminStatusFilter === "All" || b.status === adminStatusFilter).map(b => (
                    <div key={b.id} style={{ backgroundColor: '#fff', padding: '15px 20px', borderRadius: '15px', border: '1px solid #eee', position: 'relative', boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
                      <div className="admin-card">
                        <div onClick={() => { setSelectedCar(b.expand?.car_id); setView('details'); }} style={{ cursor: 'pointer', flexShrink: 0 }}>
                          <img className="admin-card-img" style={{ height: '70px', width: '100px' }} src={`https://bahcarplaza.com/api/files/${b.expand?.car_id?.collectionId}/${b.car_id}/${getVal(b.expand?.car_id?.image)}`} alt="car" />
                        </div>
                        
                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '4px' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                            <h2 style={{ margin: 0, fontSize: '15px', fontWeight: '900', color: '#002f34', textTransform: 'uppercase' }}>{b.full_name}</h2>
                            <span style={{ backgroundColor: '#E8F0FE', color: '#1A73E8', fontSize: '9px', fontWeight: '900', padding: '3px 8px', borderRadius: '8px', textTransform: 'uppercase' }}>{b.visit_type}</span>
                          </div>
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px', fontSize: '11px', fontWeight: 'bold', color: '#666' }}>
                            <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>📞 {b.phone}</span>
                            <span onClick={() => { setSelectedCar(b.expand?.car_id); setView('details'); }} style={{ display: 'flex', alignItems: 'center', gap: '5px', color: '#ef5e33', textTransform: 'uppercase', cursor: 'pointer' }}>🚗 {b.expand?.car_id?.brand} {b.expand?.car_id?.model}</span>
                            <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>🗓️ {new Date(b.booking_date).toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' })}</span>
                          </div>
                          {b.message && (
                            <div style={{ marginTop: '5px', padding: '6px 12px', backgroundColor: '#f9f9f9', borderRadius: '8px', borderLeft: '3px solid #ef5e33', fontStyle: 'italic', fontSize: '11px', color: '#555' }}>
                              💬 "{b.message}"
                            </div>
                          )}
                        </div>

                        <div className="admin-card-actions" style={{ textAlign: 'right', display: 'flex', flexDirection: 'column', gap: '6px', minWidth: '120px' }}>
                          <div style={{ color: b.status === 'Confirmed' ? '#1db954' : b.status === 'Cancelled' ? '#dc3545' : '#ef5e33', fontWeight: '900', fontSize: '10px', marginBottom: '2px' }}>• {b.status.toUpperCase()}</div>
                          <div style={{ display: 'flex', gap: '5px', justifyContent: 'flex-end' }}>
                            <button onClick={() => updateBookingStatus(b.id, 'Confirmed')} style={{ backgroundColor: '#28a745', color: '#fff', border: 'none', padding: '6px 10px', borderRadius: '6px', fontSize: '9px', fontWeight: '900', cursor: 'pointer', flex: 1 }}>CONFIRM</button>
                            <button onClick={() => updateBookingStatus(b.id, 'Cancelled')} style={{ backgroundColor: '#dc3545', color: '#fff', border: 'none', padding: '6px 10px', borderRadius: '6px', fontSize: '9px', fontWeight: '900', cursor: 'pointer', flex: 1 }}>CANCEL</button>
                          </div>
                          <button onClick={() => deleteRecord('bookings', b.id)} style={{ background: 'none', border: 'none', color: '#ccc', fontSize: '9px', fontWeight: '800', marginTop: '4px', cursor: 'pointer', textDecoration: 'underline' }}>DELETE RECORD</button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </>

            ) : adminActiveTab === 'ORDERS' ? (
              <>
                <div style={{ marginBottom: '25px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                  {['All', 'Pending', 'Processing', 'Approved', 'Delivered', 'Reject'].map(s => (
                    <button key={s} onClick={() => setOrderStatusFilter(s)} style={{ padding: '8px 25px', borderRadius: '25px', border: orderStatusFilter === s ? 'none' : '1px solid #ddd', fontSize: '11px', fontWeight: '900', textTransform: 'uppercase', cursor: 'pointer', backgroundColor: orderStatusFilter === s ? '#002f34' : '#fff', color: orderStatusFilter === s ? '#fff' : '#888', transition: '0.2s' }}>
                      {s} ({s === 'All' ? orders.length : orders.filter(o => o.payment_status === s).length})
                    </button>
                  ))}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                  {orders.filter(o => orderStatusFilter === "All" || o.payment_status === orderStatusFilter).map(o => (
                    <div key={o.id} style={{ backgroundColor: '#fff', padding: '15px 20px', borderRadius: '20px', border: '1px solid #eee', boxShadow: '0 2px 10px rgba(0,0,0,0.02)' }}>
                      <div className="admin-card" style={{ display: 'grid', gridTemplateColumns: '90px 1fr auto auto', gap: '20px', alignItems: 'center' }}>
                        <div onClick={() => { setSelectedCar(o.expand?.car_id); setView('details'); }} style={{ overflow: 'hidden', cursor: 'pointer' }}>
                          <img className="admin-card-img" style={{ height: '60px', width: '90px' }} src={`https://bahcarplaza.com/api/files/${o.expand?.car_id?.collectionId}/${o.car_id}/${getVal(o.expand?.car_id?.image)}`} alt="car" />
                        </div>
                        <div>
                          <h4 style={{ margin: '0 0 4px 0', fontWeight: '900', color: '#002f34', textTransform: 'uppercase', fontSize: '14px' }}>👤 {o.expand?.user_id?.name || o.expand?.user_id?.email}</h4>
                          <p style={{ margin: '0 0 4px 0', fontSize: '11px', color: '#666', fontWeight: 'bold' }}>📞 {o.expand?.user_id?.phone || 'N/A'}</p>
                          <p onClick={() => { setSelectedCar(o.expand?.car_id); setView('details'); }} style={{ margin: 0, fontSize: '12px', color: '#ef5e33', fontWeight: 'bold', cursor: 'pointer' }}>🚗 {o.expand?.car_id?.brand} {o.expand?.car_id?.model}</p>
                        </div>
                        <div className="admin-card-actions">
                          <p style={{ margin: '0 0 4px 0', fontWeight: '900', fontSize: '18px', color: '#002f34' }}>₹{o.amount?.toLocaleString()}</p>
                          <p style={{ margin: 0, fontSize: '10px', color: '#aaa', fontWeight: 'bold' }}>Date: {new Date(o.created).toLocaleDateString()}</p>
                        </div>
                        
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                          <select className="admin-card-actions" style={{ ...inputStyle, padding: '10px', borderRadius: '10px', cursor: 'pointer', backgroundColor: '#f9f9f9', border: '1px solid #ddd', fontWeight: 'bold', fontSize: '11px', outline: 'none' }} defaultValue={o.payment_status} onChange={(e) => updateOrderStatus(o.id, o.car_id, e.target.value)}>
                            {['Pending', 'Processing', 'Approved', 'Delivered', 'Reject'].map(s => <option key={s} value={s}>{s}</option>)}
                          </select>

                          <button 
                            onClick={() => deleteRecord('orders', o.id)} 
                            style={{ width: '100%', backgroundColor: '#fff', color: '#dc3545', border: '1px solid #dc3545', padding: '8px 10px', borderRadius: '10px', fontWeight: '900', fontSize: '10px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px', transition: '0.3s' }} 
                            onMouseOver={(e) => { e.target.style.backgroundColor = '#dc3545'; e.target.style.color = '#fff'; }} 
                            onMouseOut={(e) => { e.target.style.backgroundColor = '#fff'; e.target.style.color = '#dc3545'; }}
                          >
                            🗑️ DELETE ORDER
                          </button>
                        </div>

                      </div>
                    </div>
                  ))}
                </div>
              </>

            ) : (
              <>
                <div style={{ marginBottom: '20px', display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                  {['All', 'Pending', 'Approved', 'Rejected'].map(s => (
                    <button key={s} onClick={() => setApprovalStatusFilter(s)} style={{ padding: '8px 25px', borderRadius: '25px', border: approvalStatusFilter === s ? 'none' : '1px solid #ddd', fontSize: '11px', fontWeight: '900', textTransform: 'uppercase', cursor: 'pointer', backgroundColor: approvalStatusFilter === s ? '#002f34' : '#fff', color: approvalStatusFilter === s ? '#fff' : '#888', transition: '0.2s' }}>
                      {s} ({s === 'All' ? cars.length : cars.filter(c => c.status === s).length})
                    </button>
                  ))}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                  {cars.filter(c => approvalStatusFilter === "All" || c.status === approvalStatusFilter).map(car => (
                    <div key={car.id} style={{ backgroundColor: '#fff', padding: '20px', borderRadius: '20px', border: '1px solid #eee', boxShadow: '0 2px 10px rgba(0,0,0,0.02)' }}>
                      <div className="admin-card">
                        <img className="admin-card-img" src={`https://bahcarplaza.com/api/files/${car.collectionId}/${car.id}/${getVal(car.image)}`} onClick={() => { setSelectedCar(car); setView('details'); }} style={{ cursor: 'pointer' }} alt="" />
                        <div style={{ flex: 1 }}>
                          <h3 style={{ margin: '0 0 5px 0', fontWeight: '900', color: '#002f34', textTransform: 'uppercase', fontSize: '18px' }}>{car.brand} {car.model}</h3>
                          <p style={{ margin: '0 0 8px 0', fontSize: '12px', color: '#555', fontWeight: 'bold' }}>
                            👤 {car.expand?.added_by?.name || 'Unknown'} &nbsp;|&nbsp; 📞 {car.expand?.added_by?.phone || 'N/A'} &nbsp;|&nbsp; ✉️ {car.expand?.added_by?.email || 'N/A'}
                          </p>
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', fontSize: '11px', color: '#666', fontWeight: 'bold' }}>
                            <span style={{ backgroundColor: '#f9f9f9', padding: '4px 10px', borderRadius: '8px' }}>🗓️ {car.year}</span>
                            <span style={{ backgroundColor: '#f9f9f9', padding: '4px 10px', borderRadius: '8px' }}>📍 {getVal(car.city)}</span>
                            <span style={{ backgroundColor: '#f9f9f9', padding: '4px 10px', borderRadius: '8px', color: '#ef5e33' }}>💰 ₹{car.price?.toLocaleString()}</span>
                          </div>
                          {car.status === 'Rejected' && <p style={{ margin: '8px 0 0 0', fontSize: '12px', color: '#dc3545', fontWeight: 'bold', fontStyle: 'italic' }}>Reason: {car.rejection_reason}</p>}
                        </div>
                        
                        <div className="admin-card-actions" style={{ display: 'flex', flexDirection: 'column', gap: '8px', minWidth: '150px', textAlign: 'right' }}>
                          <span style={{ fontSize: '11px', fontWeight: '900', color: car.status === 'Approved' ? '#1db954' : car.status === 'Rejected' ? '#dc3545' : '#ef5e33', marginBottom: '5px' }}>• {car.status.toUpperCase()}</span>
                          
                          {car.status === 'Pending' && (
                            <div style={{ display: 'flex', gap: '5px', width: '100%' }}>
                              <button onClick={() => updateCarListingStatus(car.id, 'Approved')} style={{ flex: 1, backgroundColor: '#28a745', color: '#fff', border: 'none', padding: '10px 15px', borderRadius: '10px', fontWeight: '900', fontSize: '10px', cursor: 'pointer', boxShadow: '0 2px 5px rgba(40,167,69,0.2)' }}>APPROVE</button>
                              <button onClick={() => updateCarListingStatus(car.id, 'Rejected')} style={{ flex: 1, backgroundColor: '#dc3545', color: '#fff', border: 'none', padding: '10px 15px', borderRadius: '10px', fontWeight: '900', fontSize: '10px', cursor: 'pointer', boxShadow: '0 2px 5px rgba(220,53,69,0.2)' }}>REJECT</button>
                            </div>
                          )}
                          
                          <button onClick={() => deleteRecord('cars', car.id)} style={{ width: '100%', backgroundColor: '#fff', color: '#dc3545', border: '1px solid #dc3545', padding: '8px 10px', borderRadius: '10px', fontWeight: '900', fontSize: '10px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px', transition: '0.3s' }} onMouseOver={(e) => { e.target.style.backgroundColor = '#dc3545'; e.target.style.color = '#fff'; }} onMouseOut={(e) => { e.target.style.backgroundColor = '#fff'; e.target.style.color = '#dc3545'; }}>
                            🗑️ DELETE
                          </button>

                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}
          </section>

        </div>
      </div>
    </div>
  );
}

export default Admin;